import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "loading-box" }

import { Spin } from "ant-design-vue";
import { computed } from "vue";
import { i18n } from "../../../locales/index";

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  delay: {
    type: Number,
  },
  size: {
    type: String,
  },
  tip: {
    type: String,
  },
},
  setup(__props) {

const { t } = i18n.global;

const props = __props;

const showTip = computed(() => {
  if (props.tip) {
    return props.tip;
  } else {
    return t("common.Loading");
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Spin), {
      tip: showTip.value,
      spinning: true,
      delay: __props.delay
    }, null, 8, ["tip", "delay"])
  ]))
}
}

})